import { IConfigObject, IReactiveConfigurationDataSource } from '../types/configuration.types';

export function createStaticDataSource<T extends IConfigObject>(
  config: Partial<T>
): IReactiveConfigurationDataSource<T> {
  return {
    register: () => config,
    unregister: () => {
      // do nothing
    }
  };
}
